import React from 'react';
import {IntlProvider, FormattedMessage} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';

export default {
  fields: [
    {
      type: 'text',
      name: 'newPassword',
      props: {
        required: true,
        label: (
          <p>
            <i className='asterisk icon inline' />
            <IntlProvider locale='en' messages={enUSmessage}>
              <FormattedMessage id='userManagement.userDetail.modals.changePassword.newPassword' />
            </IntlProvider>
          </p>
        )
      }
    },
    {
      type: 'text',
      name: 'newPasswordConfirm',
      props: {
        required: true,
        label: (
          <p>
            <i className='asterisk icon inline' />
            <IntlProvider locale='en' messages={enUSmessage}>
              <FormattedMessage id='userManagement.userDetail.modals.changePassword.newPasswordConfirm' />
            </IntlProvider>
          </p>
        )
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/ChangePasswordModal/changePasswordFormConfig.jsx